import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/mac.svg'
import _imports_1 from '@/assets/images/hours.svg'


const _hoisted_1 = { class: "container px-5 pb-5" }
const _hoisted_2 = { class: "fw-bold mb-3" }
const _hoisted_3 = { class: "section d-flex gap-4" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "w-35" }
const _hoisted_6 = { class: "banner mb-4" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "card-info" }
const _hoisted_9 = { class: "title-card p-2" }
const _hoisted_10 = ["alt"]
const _hoisted_11 = { class: "mb-0 me-3 mx-2" }
const _hoisted_12 = { class: "body-card px-2 m-2 d-flex flex-column" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "footer-card p-3 py-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " arrow_forward ", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["title"]
const _hoisted_20 = { class: "card-info" }
const _hoisted_21 = { class: "title-card p-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "hours"
}, null, -1)
const _hoisted_23 = { class: "mb-0 me-3 mx-2" }
const _hoisted_24 = { class: "body-card px-2 m-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "Total:", -1)
const _hoisted_26 = { class: "footer-card p-3 py-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined" }, " arrow_forward ", -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Qalendar = _resolveComponent("Qalendar")!
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ConfirmDialog),
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("schedule.mySchedules")), 1),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Qalendar, {
          events: _ctx.schedules,
          config: _ctx.config,
          onEditEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEvent($event))),
          onDeleteEvent: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmDelete($event))),
          onEventWasClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startEvent($event)))
        }, null, 8, ["events", "config"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_ds_button, {
          class: "w-100",
          type: "primary",
          text: _ctx.$t('schedule.new'),
          leftIcon: "add",
          onClick: _cache[3] || (_cache[3] = () => _ctx.$router.push({ name: 'AddScheduleClient' }))
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "card-banner h-100",
            title: _ctx.$t('financial.lookInstruction'),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToMac(_ctx.nextDate.id)))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: _ctx.$t('financial.remoteMac')
                }, null, 8, _hoisted_10),
                _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.$t("financial.remoteMac")), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.nextDate.startDate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.days")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.nextDate.startDate), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.nextDate.startHour)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.hour")) + ":", 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.nextDate.startHour) + " às " + _toDisplayString(_ctx.nextDate.endHour), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("financial.noReserve")), 1)
                    ]))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("financial.lookInstruction")), 1)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
            }, _hoisted_18)
          ], 8, _hoisted_7),
          _createElementVNode("div", {
            class: "card-banner",
            title: _ctx.$t('financial.buyCredits'),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("h5", _hoisted_23, _toDisplayString(_ctx.$t("financial.creditsAvailable")), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", null, [
                  _hoisted_25,
                  _createTextVNode(" " + _toDisplayString(_ctx.currentBalance) + " " + _toDisplayString(_ctx.$t("computer.fields.credits")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("financial.buyCredits")), 1)
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push({ name: 'BuyCredits' })))
            }, _hoisted_28)
          ], 8, _hoisted_19)
        ])
      ])
    ])
  ]))
}